import divider_module_default from "./divider.module.js";
import { Divider } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/divider/Divider.tsx
const Divider$1 = ({ color, label, labelPosition, orientation, variant = "full", "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Divider, {
		"data-variant": variant,
		classNames: divider_module_default,
		label,
		labelPosition,
		orientation,
		color,
		"data-testid": testId
	});
};

//#endregion
export { Divider$1 as Divider };